<template>
  <NewClubForm
    ref="newClubForm"
    :loading="submitButtonLoading"
    @form-submit="handleFormSubmit"
  />
</template>

<script>
import NewClubForm from "../registerform/new-club-form";
import { mapGetters } from "vuex";

const CLUB_STORE_KEY = "clubStore";

export default {
  components: {
    NewClubForm
  },
  data() {
    return {
      formType: "club",
      clubInfo: {}
    };
  },
  computed: {
    ...mapGetters({
      submitButtonLoading: `${CLUB_STORE_KEY}/createClubLoading`
    })
  },
  methods: {
    handleFormSubmit(form) {
      this.dispatcher(form);
    },
    async dispatcher(form) {
      await this.$store.dispatch(`${CLUB_STORE_KEY}/createClub`, form);
      this.$refs.newClubForm.handleFormReset();
    }
  }
};
</script>

<style lang="scss"></style>
